import React from 'react';
import { block } from 'bem-cn';

import { LANGUAGES } from '../../constants';
import useLocalizedStrings from '../../hooks/useLocalizedStrings';
import './pion-dnd-overlay.scss';

const b = block('pion-dnd-overlay');

export const translations = {
  [LANGUAGES.EN]: {
    text: 'Drag & drop one or many images here',
  },
  [LANGUAGES.SV]: {
    text: 'Dra & släpp en eller flera bilder här',
  },
};

type PionDndOverlayPropsType = {
  lang: string;
};

const PionDndOverlay = ({ lang }: PionDndOverlayPropsType) => {
  const strings = useLocalizedStrings(translations, lang);

  return (
    <div className={b()} data-testid='pion-dnd-overlay'>
      <div className={b('inner')}>
        <div className={b('icon')} />
        <div className={b('text')}>{strings.text}</div>
      </div>
    </div>
  );
};

export default PionDndOverlay;
